import {
    AfterViewInit,
    Component,
    DoCheck,
    EventEmitter,
    Input,
    KeyValueDiffer,
    KeyValueDiffers,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { ApiService, ChatService, LoggerService, MiscConfig, QuestionMessage, SocketService, User } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ez-chat-question',
    styles: [require('./question.component.less')],
    template: require('./question.component.html'),
})
export class QuestionComponent implements AfterViewInit, DoCheck, OnInit, OnChanges {
    @Input() public question: QuestionMessage;
    @Input() public user: User;
    @Input() public me: User;
    @Output() private questionAnswered: EventEmitter<{id: number, responseId: number}> =
        new EventEmitter<{id: number, responseId: number}>();
    private differ: KeyValueDiffer<any, any>;
    private miscConfig: MiscConfig;
    private responses: Array<object>;

    private displayName: string;

    constructor(
        private apiService: ApiService,
        private differs: KeyValueDiffers,
        private translationService: TranslateService,
        private socketService: SocketService,
        private chatService: ChatService
    ) {}

    public ngAfterViewInit(): void {
        if (this.question.needReadsUpdate() && this.question.id > 0) {
            // this.setMessageRead();
        }
    }

    public ngOnInit() {
        this.differ = this.differs.find(this.question).create();
        // if its a user request we need to load content
        this.responses = [];
        this.apiService.miscConfig().subscribe((miscConfig: MiscConfig) => {
            this.miscConfig = miscConfig;
            if (
                miscConfig.userRequestTypes.has(this.question.userRequestTypeId)
                && miscConfig.userRequestTypes.get(this.question.userRequestTypeId).responses.size > 0
            ) {
                miscConfig.userRequestTypes.get(this.question.userRequestTypeId).responses.forEach((value: any) => {
                    this.responses.push(value);
                });
            }
        });
        this.setQuestionContent();
    }

    public ngDoCheck() {
        let changes = this.differ.diff(this.question);
        if (changes) {
            // check if systemMessage id change
            changes.forEachChangedItem(change => {
                if (change.key === 'id' && change.currentValue > 0) {
                    LoggerService.info('MESSAGE ID CHANGED');
                    this.setMessageRead();
                } else if (change.key === 'userRequestResponseId' && change.currentValue > 0) {
                    this.setQuestionContent();
                }
            });
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        // Get display names when available
        if (changes.hasOwnProperty('user') && changes.user.currentValue) {
            if (this.question.direction === 'from') {
                this.displayName = changes.user.currentValue.displayname;
            }
        }
        if (changes.hasOwnProperty('me') && changes.me.currentValue) {
            if (this.question.direction !== 'from') {
                this.displayName = changes.me.currentValue.displayname;
            }
        }
    }

    public callback(responseId) {
        // yes
        if (responseId === 1) {
            this.apiService.put('/ws/profile/picturesAuthorization', {
                userIdTo: this.user.id
            }).subscribe(data => {
                this.chatService.sendResponse(this.question, responseId);
            });
        // no
        } else if (responseId === 2) {
            this.chatService.sendResponse(this.question, responseId);
        }
        this.question.userRequestResponseId = responseId;
        this.questionAnswered.emit({
            id: this.question.id,
            responseId: responseId
        });
        this.setQuestionContent();

    }

    private setMessageRead() {
        this.apiService.put('/ws/userRequest/read', JSON.stringify({
            requests: [this.question.id]
        })).subscribe();
    }

    private setQuestionContent() {
        if (this.question.userRequestTypeId === 1) {
            let messageContent: string = '';
            switch (this.question.userRequestResponseId) {
                case 1:
                    messageContent = 'private-auth.has-accept';
                    break;
                case 2:
                    messageContent = 'private-auth.has-refused';
                    break;
                default:
                    messageContent = 'private-auth.ask-authorisation';
                    break;
            }
            messageContent += '.' + this.question.direction;
            this.question.content = messageContent;
        }
    }

    public ucFirst(string: string): string {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/chat/childs/question/question.component.ts